/**
 * Client-side attachment limits, mirroring the v2 backend allowlist
 * (`ATTACHMENT_MAX_BYTES` / `ATTACHMENT_ALLOWED_TYPES`). Checked before
 * requesting an upload SAS so obviously-invalid files fail fast.
 */
export const ATTACHMENT_MAX_BYTES = 26214400; // 25 MB

export const ATTACHMENT_ALLOWED_TYPES = [
	"application/pdf",
	"image/png",
	"image/jpeg",
	"text/plain",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
] as const;

export function formatBytes(bytes: number): string {
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Returns an error message if the file is invalid, or null if it's allowed. */
export function validateAttachmentFile(file: File): string | null {
	if (file.size > ATTACHMENT_MAX_BYTES) {
		return `"${file.name}" exceeds the ${formatBytes(ATTACHMENT_MAX_BYTES)} limit`;
	}
	if (!ATTACHMENT_ALLOWED_TYPES.includes(file.type as never)) {
		return `"${file.name}" is not an allowed file type`;
	}
	return null;
}
